import { observer } from 'mobx-react';
import React from 'react';
import { DateTimeRangePicker } from '@ole-ui/ole-ui-components';
import { useTranslation } from 'react-i18next';
import useMobxStores from 'hooks/useMobxStores';

function RangeFilters() {
  const { t } = useTranslation();
  const { premiumSessionFilterStore } = useMobxStores();
  const { from: fromDate, to: toDate } = premiumSessionFilterStore.dateRange;
  const { from: fromTime, to: toTime } = premiumSessionFilterStore.timeRange;

  return (
    <div className="live-session-filter__range-container">
      <DateTimeRangePicker
        // className="pf-v5-theme-dark" // force dark theme for correct text colors
        independentTime
        startDateTimeProps={{
          label: t('Start date'),
          helperText: t('Select start date and time'),
          dateValue: fromDate,
          timeValue: fromTime,
          onChange: (date: Date, source: string) => {
            /**
             * The DateTimeRangePicker stores date and time in the same object.
             * Our store separates date and time into two different properties.
             * We need to update the store with the correct values.
             * Not ideal, but I don't want to change the store methods at the moment.
             * */
            if (source === 'DatePicker') {
              premiumSessionFilterStore.setStartDate(date);
            } else if (source === 'TimePicker') {
              premiumSessionFilterStore.setStartTime(date);
            }
            premiumSessionFilterStore.filterEntries();
          },
          datePickerProps: {
            'aria-label': t(
              'Select start date by clicking on the calendar icon or typing the date',
            ),
            // popoverProps: {
            //   className: 'pf-v5-theme-dark', // force dark theme for calendar dark theme
            // },
          },
          timePickerProps: {
            'aria-label': t(
              'Select start time by clicking on the clock icon or typing the time',
            ),
          },
        }}
        endDateTimeProps={{
          label: t('End date'),
          helperText: t('Select end date and time'),
          dateValue: toDate,
          timeValue: toTime,
          onChange: (date: Date, source: string) => {
            if (source === 'DatePicker') {
              premiumSessionFilterStore.setEndDate(date);
            } else if (source === 'TimePicker') {
              premiumSessionFilterStore.setEndTime(date);
            }
            premiumSessionFilterStore.filterEntries();
          },
          timePickerProps: {
            'aria-label': t(
              'Select end time by clicking on the clock icon or typing the time',
            ),
          },
          datePickerProps: {
            'aria-label': t(
              'Select end date by clicking on the calendar icon or typing the date',
            ),
            // popoverProps: {
            //   className: 'pf-v5-theme-dark', // force dark theme for calendar dark theme
            // },
          },
        }}
      />
    </div>
  );
}

export default observer(RangeFilters);
